// Integrations.tsx
import React from 'react';
import { Box } from '@mui/material';
import { SettingsSection } from '../common';
import Webhooks from './Webhooks';
import ApiCredentials from './ApiCredentials';
import SupportedIntegrations from './SupportedIntegrations';

export const Integrations = () => {
  return (
    <Box
      sx={{
        flexGrow: 1,
        height: '100%',
        overflow: 'auto',
        bgcolor: 'transparent',
        px: 3,
        pt: 1,
        pb: 3,
        '& > *:not(:last-child)': {
          mb: 3,
        },
      }}
    >
      <SettingsSection title="Supported Integrations">
        <SupportedIntegrations />
      </SettingsSection>

      <SettingsSection title="Webhooks">
        <Webhooks />
      </SettingsSection>

      <SettingsSection title="API">
        <ApiCredentials />
      </SettingsSection>
    </Box>
  );
};

export default Integrations;
